import React, { useEffect, useState, type ReactNode } from "react";
import { Header, Loader } from "components/common";
import { LiveCallsIcon, CallCenterIcon } from "assets";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { setAccountId } from "../../../redux/slices/api.slice";
import { useInitialLoader } from "hooks/useInitialLoader";
import Cookies from "js-cookie";
import { useAppDispatch } from "../../../redux/hooks";

import "./defaultLayout.scss";
import { useLocation } from "react-router-dom";
import { SideBar } from "@data-phone/react-generic";
import { resetAgents } from "../../../redux/slices/agents.slice";
import { clearApps } from "../../../redux/slices/apps.slice";
interface DefaultLayoutProps {
  children: ReactNode;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  const { logout, hasAdminPermission } = useInitialLoader();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);


  const sessionData = useSelector(
    (state: RootState) => state.session.sessionData
  );
  const accounts = useSelector((state: RootState) => state.accounts.accounts);

  const [selectedAccount, setSelectedAccount] = useState<string | null>(
    Cookies.get(`last_account_id`) || null
  );

  const appMenu = [
    {
      key: "live-calls",
      label: "Live Calls",
      icon: (
        <img src={""} alt="live-calls-icon" height={"30px"} width={"30px"} />
      ),
      path: "/",
      enabled: true,
    },
    {
      key: "call-center",
      label: "Call Center",
      icon: (
        <img src={""} alt="call-center-icon" height={"30px"} width={"30px"} />
      ),
      path: "/call-center",
      enabled: true,
    },
  ];

  const routeInfo = {
    "/": {
      icon: LiveCallsIcon,
      title: "Live Calls",
    },
    "/call-center": {
      icon: CallCenterIcon,
      title: "Call Center",
    },
  }

  const icon = routeInfo[location.pathname as keyof typeof routeInfo].icon;
  const title = routeInfo[location.pathname as keyof typeof routeInfo].title || "Unknown App";

  useEffect(() => {
    if (!sessionData?.accountID) return;

    const cookieAccountId = Cookies.get("last_account_id");
    const finalAccountId = cookieAccountId || sessionData.accountID;

    setSelectedAccount(finalAccountId);
  }, [sessionData?.accountID]);

  const currentAccountId = useSelector((state: RootState) => state.appConfig.account_id);

  useEffect(() => {
    if (selectedAccount && selectedAccount !== currentAccountId) {
      dispatch(resetAgents())
      dispatch(clearApps())
      dispatch(setAccountId(selectedAccount));
    }
  }, [selectedAccount, currentAccountId]);

  const isReady =
    !!sessionData &&
    !!sessionData.permissions &&
    !!selectedAccount &&
    (hasAdminPermission ? accounts.length > 0 : true);

  if (!isReady) {
    return (
      <div className="default-layout-loading">
        <Loader />
      </div>
    );
  }

  return (
    <div className="default-layout-container">
      <SideBar
        userAccount={selectedAccount}
        appMenu={appMenu}
        permissions={
          sessionData.permissions as unknown as { [key: string]: string[] }
        }
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        appName='liveCalls'
        accounts={accounts || []}
        selectedAccountId={selectedAccount}
        setSelectedAccountId={setSelectedAccount}
      />

      <main className="content-area">
        <Header
          logout={logout}
          name={`${sessionData?.firstName} ${sessionData?.lastName}`}
          email={sessionData?.email || ""}
          icon={icon}
          title={title}
        />
        <div className="content">{children}</div>
      </main>
    </div>
  );
};

export default DefaultLayout;